import React, { useCallback, useEffect, useMemo} from 'react';
import { RouteComponentProps, useLocation } from 'react-router-dom';
import './index.scss';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import * as api from "../../api";



interface DirectDebitCallbackProps extends RouteComponentProps {}

const DirectDebitCallback: React.FC<DirectDebitCallbackProps> = ({}) => {
  const { t } = useTranslation();
  const location = useLocation();
  

  const status = useMemo(() => {
    const pathSegments = location?.pathname.split('/').filter(Boolean);
    return pathSegments?.at(-1);
  }, [location?.pathname]);

  const isSuccess = status === 'success';

  const payRef = useSelector((state: any) => state.userChoicesReducer?.accountnumber);
  const amount = useSelector((state: any) => state.userChoicesReducer?.directDebitAmount);
  const frequency = useSelector((state: any) => state.financialReferralReducer?.actualFrequency);
  const date = useSelector((state: any) => state.userChoicesReducer?.directDebitStartDate);
  const userProfileData = useSelector((state: any) => state?.userChoicesReducer?.userProfileData);

  const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const instructionId = useMemo(() => queryParams.get('instructionId') ?? null, [queryParams]);
  const customerName = [
    userProfileData?.customerResponse?.person?.name?.title,
    userProfileData?.customerResponse?.person?.name?.givenName,
    userProfileData?.customerResponse?.person?.name?.surname,
  ]
    .filter(Boolean)
    .join(' ');

  const displayAmount = useMemo(() => {
    const value = Number(amount);
    if (!Number.isNaN(value) && Number.isFinite(value)) {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(value);
    }
    return amount || '-';
  }, [amount]);

  const DD_API_CALLED_KEY = 'dd_api_called';

  const callPostEndPointForNotes = useCallback(async () => {
    const hasCalledBefore = localStorage.getItem(DD_API_CALLED_KEY) === 'true';
    if (hasCalledBefore) return;
    // Add your endpoint call logic here
    const postObj = {
      instructionIdentifier: instructionId ?? null,
      rentAmount: Number(amount) || 0,
      rentFrequency: frequency,
      startDate: date,
      endDate: null,
      status: isSuccess ? 'Success' : 'Failed',
    };
    try{
      await api.getDirectDebitPostEndPoint(payRef, postObj)
      localStorage.setItem(DD_API_CALLED_KEY, 'true');
    }catch(e:any){
      console.log("Error", e);
    }
  }, [instructionId, amount, frequency, date, isSuccess, payRef]);

  useEffect(()=>{
    callPostEndPointForNotes()
  },[callPostEndPointForNotes])
  

  const returnToHome = () => {
    localStorage.removeItem(DD_API_CALLED_KEY);
    globalThis.location.assign('/customer360View');
  };

  const viewBalance = () => {
    localStorage.removeItem(DD_API_CALLED_KEY);
    globalThis.location.assign('/viewAccount');
  };

  const openDialer = () => {
    globalThis.open("tel:"+t("DD_Unsuccess_Mob"));
  }
  
 
  return (
    <section className="padding-repair dd-pb" data-testid="direct-debit-success" aria-live="polite">
       {isSuccess?(<div data-testid="alert-warning"
                    className="successBg mb-4 py-2 mt-4">
                    <div className='flex'>
                      <div className="iconChecked">
                        <i className="fa fa-check-circle fa-lg" aria-hidden="true"></i>
                      </div>
                      <div className="px-4">
                       <h4>Direct Debit successfully set up</h4>
                       <p>{t("DD_Success_Sub_Heading")} {date || '-'}</p>
                      </div>
                    </div>
                  </div>): (
        <div data-testid="alert-warning" className="failureBg mb-4 py-2 mt-4">
          <div className="flex">
            <div className='mt-2'><div className="iconFailed bg-wt">
              <span className="iconFailed-circle">✕</span>
            </div></div>
            <div className="px-4">
              <h4>Direct Debit setup failed</h4>
              <p>Your reference: {payRef || '-'}</p>
            </div>
          </div>
        </div>
      )}

      <div className="dd-content-grid">
        <article className="dd-details-card">

          <div className="dd-row">
            <h1 className='hidden'>Customer Name</h1>
            <h6>Customer Name</h6>
            <p>{customerName || '-'}</p>
          </div>
          <div className="dd-row">
            <h6>Amount</h6>
            <p>{displayAmount}</p>
          </div>
          <div className="dd-row">
            <h6>Frequency</h6>
            <p>{frequency || '-'}</p>
          </div>
          <div className="dd-row">
            <h6>Start Date</h6>
            <p>{date || '-'}</p>
          </div>
          <div className="dd-row">
            <h6>Pay Reference</h6>
            <p>{payRef || '-'}</p>
          </div>
          <div className="dd-row">
            <h6>Outcome</h6>
            <p>{status || '-'}</p>
          </div>
          <div className="dd-row">
            <h6>Reference Number</h6>
            <p>{instructionId || '-'}</p>
          </div>
          <div className="dd-row">
            <h6>Instruction ref</h6>
            <p>{isSuccess?"Active" :"Direct Debit not setup"}</p>
          </div>
        </article>
         <article className="dd-next-steps">
      {isSuccess?(<>
            <h4>What happens next?</h4>
            <div className="dd-bullet-list">
              <div className="dd-bullet-item">
                <span className="dd-bullet">•</span>
                <span className='dd_p'>{t('DD_Bank_Confirm_Days')}</span>
              </div>
              <div className="dd-bullet-item">
                <span className="dd-bullet">•</span>
                <span className='dd_p'>{t('DD_Protected_Guarantee')}</span>
              </div>
            </div>
            <h4 className='mt-2'>Direct Debit Guarantee</h4>
            <p className='dd_p'>{t('DD_Guarantee')}</p>
          </>
       ):
        ( <><h4>What to do next</h4>
        <div className="dd-bullet-item dd-bullet-list">
                <span className="dd-bullet">•</span>
                <span className='dd_p'>{t('DD_Unsuccess')}{' '}
            <button className="underline cursor-pointer dialer-button" type="button" onClick={openDialer}>
              {'0300 123 3456,'}
            </button>{' '}
            <span aria-hidden="true">{t('Happy_to_help')}</span></span></div> </>)}
            </article>
      </div> 

      {isSuccess?<div className="dd-actions">
        <button type="button" className="primary-btn" onClick={viewBalance}>
          View balance
        </button>
        <button type="button" className="secondary-ghost-btn" onClick={returnToHome}>
         {t("Return_to_Home")}
        </button>
      </div>:<button type="button" className="secondary-ghost-btn dd-actions" onClick={returnToHome}>
         {t("Return_to_Home")}
        </button>}
    </section>
  );
};

export default DirectDebitCallback;